import EditPost from './EditPost.container';

export default EditPost;
